<template>
  <v-navigation-drawer
    v-model="scenarioBuilder.show"
    color="bg_darkish"
    temporary
    fixed
    right
    class="py-2 px-4"
    @input="(e) => !e ? showScenarioBuilder(false) : null">
    <v-row justify="center">
      <h4 class="font-weight-light dw_green--text text-uppercase text-h6 px-0 mb-2">
        <v-icon color="dw_green" class="mr-2 mb-1" v-text="mdiBullseyeArrow" />
        Scenario Builder
      </h4>
    </v-row>
    <v-divider></v-divider>
    <v-list-item class="px-0">
      <v-btn text x-small color="primary" @click.stop="$refs.scenarioForm.openModal">
        <v-icon x-small color="primary" class="mr-2" v-text="mdiFileDocumentEditOutline" />
        Details
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn text x-small color="red" @click="updateScenarioBuilder(['reset'])">
        <v-icon x-small color="red" class="mr-2" v-text="mdiCloseThick" />
        Reset All
      </v-btn>
    </v-list-item>
    <v-divider></v-divider>
    <scenario-list />

    <template v-slot:append>
      <v-divider></v-divider>
      <v-row justify="center" class="py-2">
        <p class="font-weight-light my-0 text-overline">Appendices</p>
        <v-row no-gutters>
          <v-col cols="6">
            <v-checkbox
              v-model="appendix1"
              @click="updateAppendices({ type: 'capec', data: appendix1})"
              label="CAPEC"
              hide-details
              color="dw_green"
              class="my-1 ml-3" />
          </v-col>
          <v-col cols="6">
            <v-checkbox
              v-model="appendix2"
              @click="updateAppendices({ type: 'mitre', data: appendix2})"
              label="ATT&CK"
              hide-details
              color="dw_green"
              class="my-1 ml-3" />
          </v-col>
          <v-col cols="6">
            <v-checkbox
              v-model="appendix3"
              @click="updateAppendices({ type: 'nist', data: appendix3})"
              label="NIST"
              hide-details
              color="dw_green"
              class="my-1 ml-3" />
          </v-col>
          <v-col cols="6">
            <v-checkbox
              v-model="appendix4"
              @click="updateAppendices({ type: 'cwe', data: appendix4})"
              label="CWE"
              hide-details
              color="dw_green"
              class="my-1 ml-3" />
          </v-col>
        </v-row>
      </v-row>
      <v-divider></v-divider>
      <v-row justify="center" class="py-2">
        <p class="font-weight-light my-0 text-overline">Export Scenario</p>
        <div class="d-flex">
          <v-btn
            @click="exportScenarioPDF"
            :disabled="scenarioBuilder.plays.length < 1"
            text
            small
            color="dw_green">
            <v-icon small color="dw_green" class="mr-2 my-1" v-text="mdiTextBoxMultiple" />
            To PDF
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            @click="exportScenarioCSV"
            :disabled="scenarioBuilder.plays.length < 1"
            text
            small
            color="dw_green">
            <v-icon small color="dw_green" class="mr-2 my-1" v-text="mdiFileTableBoxMultiple" />
            To CSV
          </v-btn>
        </div>
      </v-row>
    </template>
    <scenario-form ref="scenarioForm" />
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import {
  mdiBullseyeArrow,
  mdiFileDocumentEditOutline,
  mdiCloseThick,
  mdiTextBoxMultiple,
  mdiFileTableBoxMultiple
} from '@mdi/js';
import scenarioList from '@/components/playbook/scenarioBuilder/scenarioList.vue';
import scenarioForm from '@/components/playbook/scenarioBuilder/scenarioForm.vue';

export default {
  name: 'scenarioBuilder',
  components: {
    scenarioList,
    scenarioForm
  },
  data() {
    return {
      mdiBullseyeArrow,
      mdiFileDocumentEditOutline,
      mdiCloseThick,
      mdiTextBoxMultiple,
      mdiFileTableBoxMultiple,
      appendix1: false,
      appendix2: false,
      appendix3: false,
      appendix4: false
    };
  },
  computed: {
    ...mapGetters([
      'scenarioBuilder'
    ])
  },
  methods: {
    ...mapActions([
      'updateScenarioBuilder',
      'generateScenarioReport',
      'generateScenarioToCSV'
    ]),
    ...mapMutations([
      'showScenarioBuilder',
      'updateAppendices'
    ]),
    async exportScenarioPDF() {
      try {
        const html = await this.generateScenarioReport();
        const pdfWindow = window.open('');
        pdfWindow.document.write(html);
        pdfWindow.print();
      } catch (err) {
        console.error(err);
      }
    },
    async exportScenarioCSV() {
      try {
        const encodedUris = await this.generateScenarioToCSV();
        const {
          playCSV,
          capecCSV,
          teqCSV,
          ctrlCSV,
          cweCSV
        } = encodedUris;
        const link = document.createElement('a');
        if (playCSV.length > 0) {
          link.setAttribute('href', playCSV);
          link.setAttribute('download', 'Scenario Plays.csv');
          document.body.appendChild(link);
          link.click();
        }
        if (capecCSV.length > 0) {
          link.setAttribute('href', capecCSV);
          link.setAttribute('download', 'Scenario Attack Patterns.csv');
          document.body.appendChild(link);
          link.click();
        }
        if (teqCSV.length > 0) {
          link.setAttribute('href', teqCSV);
          link.setAttribute('download', 'Scenario Techniques.csv');
          document.body.appendChild(link);
          link.click();
        }
        if (ctrlCSV.length > 0) {
          link.setAttribute('href', ctrlCSV);
          link.setAttribute('download', 'Scenario Controls.csv');
          document.body.appendChild(link);
          link.click();
        }
        if (cweCSV.length > 0) {
          link.setAttribute('href', cweCSV);
          link.setAttribute('download', 'Scenario Weaknesses.csv');
          document.body.appendChild(link);
          link.click();
        }
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>
